export enum UserType {
    /// <summary>
    /// 管理用户
    /// </summary>
    ManagementUser = "管理用户",

    /// <summary>
    /// 应用用户
    /// </summary>
    AppUser = " 应用用户"
}

export const UserTypeConstant ={
    ManagementUser :"ManagementUser",
    AppUser:"AppUser"
}